import React from "react";
import { useFBannerSpendResponsive } from "./hooks/useFBannerSpendResponsive";
import styles from "./style/FBannerSpendResponsive.module.scss";
import classNames from "classnames";

const FBannerSpendResponsive = ({ title = "", img, subTitle = "" }) => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 flex justify-center">
      <div className="grid grid-cols-4 border-0 grid-rows-3 gap-3 w-64 sm:w-full">
        <div className="col-span-4 sm:col-span-2  border-0 row-span-3 flex items-center place-content-center">
          <img className="w-28 sm:w-38 h-22 sm:h-32" src={img} />
        </div>
        <div className="col-span-4 sm:col-span-2  border-0 text-2xl font-bold flex items-center text-center place-content-center">
          {title}
        </div>
        <div className="col-span-4 sm:col-span-2  border-0 text-xl flex items-center place-content-center">
          {subTitle}
        </div>
      </div>
    </div>
  );
};

export default FBannerSpendResponsive;
